define(['./object/keys', './object/keysIn', './object/merge', './object/pairs'], function(keys, keysIn, merge, pairs) {
  return {
    'keys': keys,
    'keysIn': keysIn,
    'merge': merge,
    'pairs': pairs
  };
});



/*****************
 ** WEBPACK FOOTER
 ** ./components/core/vendor/lodash/object.js
 ** module id = 30
 ** module chunks = 0
 **/